<template>
  <div class="checkpoint">
    <input
      :id="'addon-' + checkpoint.id"
      type="checkbox"
      class="checkbox"
      v-model="answered"
    />
    <label class="box" :for="'addon-' + checkpoint.id"></label>
    <label :for="'addon-' + checkpoint.id" class="text" v-html="checkpoint.text" ref="textLabel">
    </label>
  </div>
</template>

<script>
export default {
  name: "QuestionCheckpoint",
  props: ["checkpoint"],
  data() {
    return {
      answered: false,
      loaded: false,
    };
  },
  mounted() {
    this.answered = this.checkpoint.answered;
    this.$nextTick(() => { //with this we skip the first change
        this.loaded = true;
        this.makeLinksOpenInNewTab();
    })
  },
  methods: {
    makeLinksOpenInNewTab() {
      const label = this.$refs.textLabel;
      if (!label) return;

      const links = label.querySelectorAll("a");
      links.forEach((link) => {
        link.setAttribute("target", "_blank");
        link.setAttribute("rel", "noopener noreferrer");
      });
    },
  },
  watch: {
    "answered": function (newVal, oldVal) {
      if(this.loaded && newVal != oldVal)
        this.$emit("onUpdate", newVal);
    },
    "checkpoint.text": function () {
      this.$nextTick(() => {
        this.makeLinksOpenInNewTab();
      });
    },
  },
};
</script>